<div *ngIf="message">
  <small class="warning-feedback d-flex align-items-middle " [style.display]="'block'" role="alert">
    <mat-icon>warning</mat-icon>
    <span>{{message}}</span>
  </small>
</div>
